import PropTypes from 'prop-types';
import isRTL from '../v2/utils/isRTL';

const ChevronLeftIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 25"
    width="24px"
    height="24px"
    fill="#fff"
    data-test="ChevronLeftIcon"
    transform={props.rtlSensitive && isRTL() ? 'rotate(180)' : undefined}
  >
    <path d="M15 16.137L10.78 12 15 7.863 13.61 6.5 8 12 13.61 17.5z" transform="translate(0 1)" />
  </svg>
);

ChevronLeftIcon.propTypes = {
  rtlSensitive: PropTypes.bool,
};

ChevronLeftIcon.defaultProps = {
  rtlSensitive: false,
};

export default ChevronLeftIcon;
